'use client';

import { SetStateAction, useState } from 'react';
import PrefectureMultiModalJob from '~/components/shared/prefecture-multi-modal-job';
import { InputItems } from '~/types/entry-members-form';

interface Step2Props {
  isMobile: boolean;
  areasWithPrefectures: any[];
  prefectures: any[];
  inputItems: InputItems;
  prefectureErrorMessage: string;
  birthYearErrorMessage: string;
  nameErrorMessage: string;
  onBack: () => void;
  onNext: (input: InputItems) => void;
}

export default function Step2({
  isMobile,
  areasWithPrefectures,
  prefectures,
  inputItems,
  prefectureErrorMessage,
  birthYearErrorMessage,
  nameErrorMessage,
  onBack,
  onNext,
}: Step2Props) {
  const currentYear = new Date().getFullYear();
  const maxBirthYear = currentYear - 18;
  const birthYears = Array.from(
    { length: maxBirthYear - 1945 + 1 },
    (_, i) => 1945 + i,
  );

  const [birthYear, setBirthYear] = useState('');
  const [name, setName] = useState('');
  const [selectedPrefectureIds, setSelectedPrefectureIds] = useState<number[]>(
    [],
  );

  return (
    <>
      {/* ご希望の勤務地 */}
      <div className="p-horizontal-slide__form">
        <div className="p-horizontal-slide__header">
          <div className="u-flex -items-center u-gap8">
            <span className="c-label -bg-red">必須</span>
            <div className="u-font-bold">ご希望の勤務地</div>
          </div>
        </div>
        <div className="p-horizontal-slide__body">
          <PrefectureMultiModalJob
            prefectures={prefectures}
            areasWithPrefectures={areasWithPrefectures}
            selectedPrefectureIds={selectedPrefectureIds}
            errorMessage={prefectureErrorMessage}
            isMobile={isMobile}
            setSelectedPrefectureIds={(
              PrefectureIds: SetStateAction<number[]>,
            ) => setSelectedPrefectureIds(PrefectureIds)}
          />
        </div>
      </div>

      <hr className={!isMobile ? 'u-mt20 u-mb40' : 'u-mt10 u-mb20'} />

      {/* 生まれた年 */}
      <div className="p-horizontal-slide__form">
        <div className="p-horizontal-slide__header">
          <div className="u-flex -items-center u-gap8">
            <span className="c-label -bg-red">必須</span>
            <div className="u-font-bold">生まれた年</div>
          </div>
        </div>
        <div className="p-horizontal-slide__body">
          <div
            className={`c-select-wrapper u-mt0 ${
              !isMobile ? 'u-wp90' : '-full-width'
            }`}
          >
            <select
              className="about-input"
              value={birthYear}
              onChange={(e) => setBirthYear(e.target.value)}
            >
              <option value="">生まれた年を選択</option>
              {birthYears.map((year) => (
                <option key={year} value={`${year}年`}>
                  {year}年
                </option>
              ))}
            </select>
          </div>
          <div className="p-entry-form__input__error u-h-1em u-mt8">
            {birthYearErrorMessage}
          </div>
        </div>
      </div>

      <hr className={!isMobile ? 'u-mt20 u-mb40' : 'u-mt10 u-mb20'} />

      {/* 氏名 */}
      <div className="p-horizontal-slide__form">
        <div className="p-horizontal-slide__header">
          <div className="u-flex -items-center u-gap8">
            <span className="c-label -bg-red">必須</span>
            <div className="u-font-bold">氏名</div>
            <span className="u-color-gray u-fs14">(複数選択可)</span>
          </div>
        </div>
        <div className="p-horizontal-slide__body">
          <input
            type="text"
            className={`c-input -inline -no-shadow -border ${
              !isMobile ? 'u-wp90' : ''
            }`}
            placeholder="建職　太郎"
            value={name}
            onChange={(e) => setName(e.target.value)}
          />
          <div className="p-entry-form__input__error u-h-1em u-mt8">
            {nameErrorMessage}
          </div>
        </div>
      </div>

      <div className="p-horizontal-slide__actions">
        <span className="p-horizontal-slide__prev-link" onClick={onBack}>
          前に戻る
        </span>
        <button
          type="button"
          className="c-button -horizontal-slide -arrow-right"
          onClick={() =>
            onNext({
              ...inputItems,
              desired_workplace_id: selectedPrefectureIds,
              birth_year: birthYear,
              name: name,
            })
          }
        >
          次へ進む
        </button>
      </div>
    </>
  );
}
